// frontend/src/components/career/CareerStepItem.tsx

import { CareerStep } from '../../types/career.types';

interface CareerStepItemProps {
  step: CareerStep;
  index: number;
}

export function CareerStepItem({ step, index }: CareerStepItemProps) {
  const isCompleted = step.status === 'completed';
  const isCurrent = step.status === 'current';

  return (
    <div className={`career-step ${isCompleted ? 'completed' : ''}`}>
      <div className={`career-step-number ${isCompleted ? 'completed' : 'pending'}`}>
        {isCompleted ? '✅' : index + 1}
      </div>
      <div className="career-step-info">
        <h4>{step.title}</h4>
        {step.description && <p>{step.description}</p>}
      </div>
      <div className="career-step-duration">
        {step.durationMonths > 0 && `${step.durationMonths} Ay • `}
        {isCompleted ? 'Tamamlandı' : isCurrent ? 'Devam Ediyor' : 'Kilitli'}
      </div>
    </div>
  );
}
